import { ROLE_SHORT } from '@/lib/roles';

export const RoleBadge = ({ role, className = '', size = 'sm' }) => {
  if (!role) return null;
  const label = ROLE_SHORT[role] || role;
  const cls = role === 'owner' ? 'chip-accent'
    : role === 'dm_creative' || role === 'dm_technical' || role === 'dm_architecture' ? 'chip-info'
    : '';
  return (
    <span data-testid="role-badge" className={`chip ${cls} ${className}`}>{label}</span>
  );
};
